module.exports = __webpack_public_path__ + "img/ic_googleplay_logo@2x.43e640da.png";